import ContentCard from "../../../Components/ContentCard";
import PDFMerger from "../../../Components/PDFMerger";
import { Helmet } from "react-helmet-async";

const Merger = () => {
    return (
        <>
            <Helmet>
                <title>PDF zusammenfügen – kostenlos online | FileForge</title>
                <meta name="description" content="Fügen Sie mehrere PDF-Dateien kostenlos zu einer einzigen Datei zusammen – ohne Anmeldung, direkt im Browser." />
                <link rel="canonical" href="https://www.file-forge.org/pdf-zusammenfuegen" />
            </Helmet>

            <ContentCard
                title="PDF Zusammenfügen"
                description="Fügen Sie mehrere PDF-Dateien zu einer einzigen Datei zusammen."
                baseClases="p-6 m-2 border flex flex-col gap-4 w-full"
            >
                <PDFMerger />
            </ContentCard>
        </>
    )
}

export default Merger